<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
          <button
            v-if="isInvoice"
            type="button"
            class="btn btn-icon btn-success mar-rt-10 save"
            style="margin-bottom: 0;"
            @click.prevent="saveInvoice"
            :title="$t('general.save')"
          >
            <img src="/static/img/icons/save.png" />
            {{ $t('invoice.invoiced') }}
          </button>

          <button
            v-else
            type="submit"
            class="btn btn-icon btn-success mar-rt-10 save"
            style="margin-bottom: 0;"
            @click.prevent="validate"
            :title="$t('general.save')"
          >
            <img src="/static/img/icons/save.png" />
            {{ $t('general.save') }}
          </button>
        </p>
      </div>
    </div>

    <div class="row mar-to-15">
      <div class="col-md-4">
        <div class="card">
          <div class="card-content">
            <h5>{{ $t('invoice.invoiceDetails') }}</h5>
            <div class="form-group">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocationId" :disabled="isEdit || isAviz">
                <option value="" disabled>Selectează locația</option>
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.true_id"
                    :value="loc.true_id"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
            <div class="form-group">
              <label>{{ $t('invoice.issueDate') }}</label>
              <input type="datetime-local" class="form-control" v-model="issueDate" :max="today"/>
            </div>

            <div class="form-group">
              <label>{{ $t('invoice.dueDate') }}</label>
              <input type="datetime-local" class="form-control" v-model="dueDate" :max="today"/>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label>{{ $t('invoice.series') }}*</label>
                <select class="form-control" v-model="seriesNumber" @change="updateNumber">
                  <option value="" disabled>{{ $t('invoice.selectSeries') }}</option>
                  <option
                    v-for="series in seriesOptionsWithAdd"
                    :key="series.id || series.series"
                    :value="series.id || series.series"
                  >
                    {{ series.nume || series.series }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label>{{ $t('gestiune.currentNumber') }}</label>
                <input type="number" class="form-control" v-model="currentNumber" disabled/>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-content">
            <h5>{{ $t('invoice.client') }}</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.vatPayer') }}*</label>
                  <select class="form-control" v-model="clientVATPayer">
                    <option value="yes">{{ $t('invoice.yes') }}</option>
                    <option value="no">{{ $t('invoice.no') }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.legalStatus') }}*</label>
                  <select class="form-control" v-model="clientLegalStatus">
                    <option value="fizica">{{ $t('invoice.statusLegal.fizica') }}</option>
                    <option value="juridica_ro">{{ $t('invoice.statusLegal.juridicaRo') }}</option>
                    <option value="juridica_eu">{{ $t('invoice.statusLegal.juridicaEu') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientName') }}*</label>
                    <v-select
                      v-model="clientSelected"
                      :options="clientResults"
                      label="nume"
                      placeholder="Caută un client..."
                      :filterable="false"
                      :disabled="!selectedLocation"
                      @search="fetchClients"
                      @input="onClientSelect"
                    />
                    <div class="v-select-loader" v-if="loading"></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientCUI') }}*</label>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('invoice.clientCUI')"
                    :value="clientCUI"
                    v-validate="modelValidate.clientCUI"
                    @input="clientCUI = $event.target.value"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientEmail') }}</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="clientEmail"
                    :placeholder="$t('invoice.clientEmail')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientPhone') }} *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="clientPhone"
                    v-validate="modelValidate.clientPhone"
                    :placeholder="$t('invoice.clientPhone')"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('invoice.clientAddress') }}*</label>
              <input
                type="text"
                class="form-control"
                v-model="clientAddress"
                v-validate="modelValidate.clientAddress"
                :placeholder="$t('invoice.clientAddress')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-content">
            <h5>{{ $t('invoice.otherDetails') }}</h5>
            <div class="form-group">
              <label>{{ $t('invoice.currency') }}*</label>
              <select class="form-control" v-model="currency">
                <option value="RON">RON</option>
                <option value="EUR">EUR</option>
                <option value="USD">USD</option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ $t('invoice.language') }}</label>
              <select class="form-control" v-model="language">
                <option value="ro">Română</option>
                <option value="en">English</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="box">
                <div class="title">
                  <p>{{ $t('gestiune.addProductInAviz') }}</p>
                </div>
                <div v-if="!isAviz" class="search">
                  <input
                    type="text"
                    v-model="searchTerm"
                    class="form-control"
                    placeholder="Search Order Id..."
                  />
                  <div class="btn btn-icon btn-search" :title="$t('reports.search')" @click="searchOrder"><i class="ti-search"></i></div>
                </div>
              </div>
              <hr class="sm" />
            </div>
          </div>
          <template>
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{ $t('gestiune.gestiune') }}*</th>
                    <th>{{ $t('invoice.productName') }}*</th>
                    <th>{{ $t('invoice.type') }}*</th>
                    <th>{{ $t('gestiune.codeProduct') }}*</th>
                    <th>{{ $t('invoice.unitMeasure') }}*</th>
                    <th>{{ $t('invoice.quantity') }}*</th>
                    <th>{{ $t('invoice.vatRate') }}</th>
                    <th>{{ $t('gestiune.pretFaraTva') }}*</th>
                    <th>{{ $t('gestiune.valoare') }}</th>
                    <th>TVA</th>
                    <th v-if="!isDisabled && !isEdit">{{ $t('general.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>{{ getGestiuneName(item.gestiuneFrom) }}</td>
                    <td>{{ typeof item.productName === 'object' ? item.productName.name : item.productName }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.code }}</td>
                    <td>{{ item.unitMeasure }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.vatRate }}%</td>
                    <td>{{ item.priceRON }}</td>
                    <td>{{ item.valoare }}</td>
                    <td>{{ item.tva }}</td>
                    <td v-if="!isDisabled && !isEdit">
                      <a class="btn btn-danger btn-icon delete mar-rt-10" @click="removeItem(index)" :disabled="isAviz">
                          <img src="/static/img/icons/icon-close.png">
                          {{$t('general.delete')}}
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!isInvoice && !isEdit && !isAviz && !isDisabled">
                    <td>
                      <select v-model="newItem.gestiuneId" class="form-control">
                        <option disabled :value="null">Selectează gestiunea</option>
                        <option
                          v-for="gestiune in filteredGestiuni"
                          :key="gestiune.id"
                          :value="gestiune.id"
                        >
                          {{ gestiune.name }}
                        </option>
                      </select>
                    </td>
                    <td style="width: 250px !important;">
                      <v-select
                        v-model="newItem.productName"
                        :options="searchResults"
                        label="name"
                        placeholder="Caută un produs..."
                        :filterable="false"
                        @search="fetchProducts"
                        @input="onProductSelected"
                      >
                        <template #no-options>
                          <span v-if="!loadingProducts">Niciun produs găsit</span>
                        </template>
                      </v-select>

                      <div class="v-select-loader-product" v-if="loadingProducts"></div>
                    </td>
                    <td>
                      <select v-model="newItem.type" class="form-control" :disabled="true">
                        <option value="">Tip</option>
                        <option value="Marfa">Marfa</option>
                        <option value="Materii prime">Materii prime</option>
                        <option value="Materiale consumabile">Materiale consumabile</option>
                        <option value="Semifabricate (Reteta)">Semifabricate (Reteta)</option>
                        <option value="Produs finit (Reteta)">Produs finit (Reteta)</option>
                        <option value="Produs rezidual">Produs rezidual</option>
                        <option value="Ambalaje">Ambalaje</option>
                        <option value="Obiecte de inventar">Obiecte de inventar</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newItem.code"
                        :disabled="true"
                        placeholder="Cod"
                      />
                    </td>
                    <td>
                      <el-select
                        v-model="newItem.unitMeasure"
                        :disabled="true"
                        placeholder="Selectează unitatea de măsură"
                      >
                        <!-- <el-option
                          v-for="option in unitMeasureOptions"
                          :key="option"
                          :label="option"
                          :value="option"
                        ></el-option> -->
                      </el-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="newItem.quantity"
                        :placeholder="$t('invoice.quantity')"
                      />
                    </td>
                    <td>
                      <el-select
                        v-model="newItem.vatRate"
                        placeholder="Cota TVA"
                      >
                        <el-option
                          v-for="vat in vats"
                          :key="vat.tax_id"
                          :label="`${vat.amount} %`"
                          :value="vat.amount"
                        />
                      </el-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="newItem.priceRON"
                        :placeholder="$t('gestiune.pretFaraTva')"
                      />
                    </td>
                    <td>
                      <el-select
                        v-model="newItem.includeVAT"
                        placeholder="Prețul include TVA?"
                      >
                        <el-option label="Cu TVA" value="yes"></el-option>
                        <el-option label="Fără TVA" value="no"></el-option>
                      </el-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        disabled
                        v-model.number="newItem.tva"
                        :placeholder="$t('gestiune.tva')"
                      />
                    </td>
                    <td>
                      <button class="btn btn-primary" @click="addItem">
                        {{ $t('general.add') }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <div class="totals-container">
            <div class="total-row">
              <span class="label">Total fara TVA:</span>
              <span class="value">{{ totalFaraTva.toFixed(2) }} RON</span>
            </div>
            <div class="total-row">
              <span class="label">Total TVA:</span>
              <span class="value">{{ totalTva.toFixed(2) }} RON</span>
            </div>
            <div class="total-row" v-if="totalCorectie !== 0">
              <span class="label">Corectie Document:</span>
              <span class="value">{{ totalCorectie.toFixed(2) }} RON</span>
            </div>
            <div class="total-row total-final">
              <span class="label">Total:</span>
              <span class="value">{{ totalFinal.toFixed(2) }} RON</span>
            </div>
          </div>
        </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <h5>Detalii Client</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="intocmitDe">Întocmit de</label>
                  <input type="text" id="intocmitDe" class="form-control" placeholder="Numele persoanei" v-model="extraFields.intocmitDe" />
                </div>
                <div class="form-group">
                  <label for="cnp">CNP</label>
                  <input type="text" id="cnp" class="form-control" placeholder="Cod Numeric Personal" v-model="extraFields.cnp" />
                </div>
                <div class="form-group">
                  <label for="delegat">Delegat</label>
                  <input type="text" id="delegat" class="form-control" placeholder="Numele delegatului" v-model="extraFields.delegat" />
                </div>
                <div class="form-group">
                  <label for="carteIdentitate">Carte Identitate</label>
                  <input type="text" id="carteIdentitate" class="form-control" placeholder="Seria și numărul cărții de identitate" v-model="extraFields.carteIdentitate" />
                </div>
                <div class="form-group">
                  <label for="auto">Auto</label>
                  <input type="text" id="auto" class="form-control" placeholder="Marca și modelul auto" v-model="extraFields.auto" />
                </div>
                <div class="form-group">
                  <label for="agentVanzari">Agent vânzări</label>
                  <input type="text" id="agentVanzari" class="form-control" placeholder="Numele agentului de vânzări" v-model="extraFields.agentVanzari" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="punctDeLucruClient">Punct de Lucru Client</label>
                  <input type="text" id="punctDeLucruClient" class="form-control" placeholder="Locația punctului de lucru" v-model="extraFields.punctDeLucruClient" />
                </div>
                <div class="form-group">
                  <label for="numarComandaBT13">Număr comandă BT-13</label>
                  <input type="text" id="numarComandaBT13" class="form-control" placeholder="Numărul comenzii" v-model="extraFields.numarComandaBT13" />
                </div>
                <div class="form-group">
                  <label for="numarContractBT12">Număr contract BT-12</label>
                  <input type="text" id="numarContractBT12" class="form-control" placeholder="Numărul contractului" v-model="extraFields.numarContractBT12" />
                </div>
                <div class="form-group">
                  <label for="referintaProiectBT11">Referință proiect BT-11</label>
                  <input type="text" id="referintaProiectBT11" class="form-control" placeholder="Codul proiectului" v-model="extraFields.referintaProiectBT11" />
                </div>
                <div class="form-group">
                  <label for="identificatorCumparatorBT46">Identificator cumpărător BT-46</label>
                  <input type="text" id="identificatorCumparatorBT46" class="form-control" placeholder="ID-ul cumpărătorului" v-model="extraFields.identificatorCumparatorBT46" />
                </div>
                <div class="form-group">
                  <label for="numarAvizReceptieBT15">Număr aviz recepție BT-15</label>
                  <input type="text" id="numarAvizReceptieBT15" class="form-control" placeholder="Numărul avizului" v-model="extraFields.numarAvizReceptieBT15" />
                </div>
                <div class="form-group">
                  <label for="referintaContabilaCumparatorBT19">Referință contabilă cumpărător BT-19</label>
                  <input type="text" id="referintaContabilaCumparatorBT19" class="form-control" placeholder="Referința contabilă" v-model="extraFields.referintaContabilaCumparatorBT19" />
                </div>
                <div class="form-group">
                  <label for="dataLivrarii">Data livrării</label>
                  <input type="date" id="dataLivrarii" class="form-control" v-model="extraFields.dataLivrarii" />
                </div>
                <div class="form-group">
                  <label for="dataIncasarii">Data încasării</label>
                  <input type="date" id="dataIncasarii" class="form-control" v-model="extraFields.dataIncasarii" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="notaInterna">Notă internă</label>
              <textarea id="notaInterna" class="form-control" placeholder="Informații suplimentare" v-model="extraFields.notaInterna"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ManagementClientsAdd :groupedLocations="groupedLocations"/>

    <ManagementSeriesAdd
      :locations="locations"
      :grouped-locations="groupedLocations"
      :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
      @getSeries="getSeries"
    />
  </div>
</template>


  <script>
  import swal from 'sweetalert2'
  import ManagementClientsAdd from '../../Management/Nomenclator/ManagementClientsAdd.vue'
  import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'

  function getLocalDateTimeString () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  export default {
    components: {
      ManagementClientsAdd,
      ManagementSeriesAdd
    },
    data () {
      return {
        loading: false,
        loadingProducts: false,
        selectedLocationId: '',
        isEdit: false,
        isInvoice: false,
        searchTerm: '',
        currentNumber: '',
        clientName: '',
        clientCUI: '',
        clientEmail: '',
        clientPhone: '',
        clientAddress: '',
        clientVATPayer: 'yes',
        clientLegalStatus: 'juridica_ro',
        issueDate: getLocalDateTimeString(),
        dueDate: getLocalDateTimeString(),
        seriesNumber: '',
        currency: 'RON',
        language: 'ro',
        productName: '',
        quantity: 0,
        priceRON: 0,
        vatRate: 0,
        includeVAT: 'no',
        vatNumber: null,
        isDisabled: false,
        searchResults: [],
        items: [],
        vats: [],
        selectedLocation: null,
        clientResults: [],
        clientSelected: null,
        gestiuneOptions: [],
        descarcaGestiunea: false,
        newItem: {
          gestiuneId: null,
          productName: '',
          unitMeasure: 'buc',
          quantity: 1,
          priceRON: null,
          vatRate: '',
          includeVAT: 'no',
          type: '',
          code: ''
        },
        fetchClientsCalled: false,
        modelValidate: {
          clientCUI: { required: true },
          clientName: { required: true },
          clientAddress: { required: true },
          productName: { required: true },
          clientPhone: { required: true },
          unitMeasure: { required: true },
          quantity: { required: true },
          priceRON: { required: true },
          vatRate: { required: true },
          includeVAT: { required: true }
        },
        myOrder: {},
        extraFields: {
          intocmitDe: '',
          cnp: '',
          delegat: '',
          carteIdentitate: '',
          auto: '',
          agentVanzari: '',
          punctDeLucruClient: '',
          numarComandaBT13: '',
          numarContractBT12: '',
          referintaProiectBT11: '',
          identificatorCumparatorBT46: '',
          numarAvizReceptieBT15: '',
          referintaContabilaCumparatorBT19: '',
          dataLivrarii: '',
          dataIncasarii: '',
          notaInterna: ''
        },
        isAviz: false,
        locations: [],
        seriesOptions: [],
        gestiuniList: []
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.seriesOptions,
          { id: 'add', nume: '➕ Adaugă serie' }
        ]
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'
          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocationId) return []
        const result = this.gestiuneOptions.filter(
          (g) => g.externalLocationId === this.selectedLocationId
        )
        return result
      },
      totalFaraTva () {
        return this.items.reduce((acc, item) => {
          const qty = Number(item.quantity) || 0
          const priceNoVAT = Number(item.priceRON) || 0
          return acc + priceNoVAT * qty
        }, 0)
      },
      totalTva () {
        return this.items.reduce((acc, item) => {
          const qty = Number(item.quantity) || 0
          const priceNoVAT = Number(item.priceRON) || 0
          const vat = Number(item.vatRate) || 0
          // TVA = preț fără TVA * cota TVA / 100
          return acc + (priceNoVAT * vat / 100) * qty
        }, 0)
      },
      totalCorectie () {
        return 0
      },
      totalFinal () {
        return this.totalFaraTva + this.totalTva + this.totalCorectie
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      const invoiceId = this.route && this.route.params && this.route.params.id
      const path = this.route && this.route.path

      if (invoiceId !== 'add') {
        const [series, invoiceNumber] = invoiceId.split('-')

        if (!series || !invoiceNumber) {
          console.error('Invalid invoice ID format')
          return
        }

        this.series = series
        this.invoiceNumber = invoiceNumber

        if (this.route.query.edit === 'true') {
          this.isEdit = true
        } else {
          this.isInvoice = path.includes('outputs')
        }
      }
      this.fetchGestiuni()
      this.fetchLocation()
    },
    watch: {
      selectedLocationId (id) {
        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code)

              this.loadVats(loc.true_id)
            }
            break
          }
        }
      },
      locations (newLocations) {
        if (newLocations && newLocations.length) {
          const { series, number, isAviz } = this.route.query
          this.isAviz = (isAviz === 'true' || isAviz === true)

          if (this.isAviz) {
            this.fetchOrder(series, number)
          }

          const invoiceId = this.route.params.id
          console.log(invoiceId, this.isAviz)
          if (invoiceId && (this.isInvoice || this.isEdit)) {
            if (this.selectedLocation && this.selectedLocation.inv_fiscal_code) {
              this.getSeries(this.selectedLocation.inv_fiscal_code)
            }
            this.getInvoiceDetails(invoiceId)
          }
        }
      },
      clientCUI (newCUI) {
        if (this.isInvoice || this.isEdit || this.isAviz) {
          return
        }

        if (this.fetchClientsCalled) return

        if (newCUI.length >= 8) {
          this.fetchCompanyDetails(newCUI)
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveAviz() }
        })
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      parseDateTimeLocal (dateString) {
        if (!dateString) return ''
        const d = new Date(dateString)
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        const hh = String(d.getHours()).padStart(2, '0')
        const min = String(d.getMinutes()).padStart(2, '0')
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`
      },
      async loadVats (locationId) {
        this.vats = await this.fetchVats(locationId)
      },
      onClientSelect (client) {
        if (client && client.id === 'add') {
          this.openAddClientModal()
          this.clientSelected = null
          this.clientName = ''
          this.clientCUI = ''
          this.clientEmail = ''
          this.clientPhone = ''
          this.clientAddress = ''
        } else if (client) {
          this.clientSelected = client

          // Precompletăm câmpurile din v-model
          this.clientName = client.fullData.name || ''
          this.clientCUI = client.fullData.vatNumber || client.vatNumber || ''
          this.clientEmail = client.fullData.email || ''
          this.clientPhone = client.fullData.phone || ''
          this.clientAddress = client.fullData.address || ''
        } else {
          this.clientSelected = null
          this.clientName = ''
          this.clientCUI = ''
          this.clientEmail = ''
          this.clientPhone = ''
          this.clientAddress = ''
        }
      },
      openAddClientModal () {
        this.client = {
          companyName: '',
          abbreviation: '',
          CUI: '',
          email: '',
          registrationNumber: '',
          address: '',
          bank: '',
          IBAN: '',
          dueDays: null,
          id: null,
          _rev: null
        }
        this.$modal.show('addClientModal')
      },
      async fetchClients (query) {
        this.fetchClientsCalled = true

        const vatNumber = this.selectedLocation && this.selectedLocation.inv_fiscal_code

        this.loading = true
        try {
          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/customers` +
            `?name=${encodeURIComponent(query)}` +
            `&externalCompanyId=${this.companyID}` +
            (vatNumber ? `&vatNumber=${encodeURIComponent(vatNumber)}` : '')

          const response = await fetch(url)
          const data = await response.json()

          if (Array.isArray(data.customers)) {
            this.clientResults = [
              ...data.customers.map(client => ({
                id: client._id,
                nume: client.name,
                vatNumber: client.vatNumber,
                fullData: client
              })),
              { id: 'add', nume: '➕ Adaugă client' }
            ]
          } else {
            this.clientResults = [
              { id: 'add', nume: '➕ Adaugă client' }
            ]
          }
        } catch (error) {
          console.error('Error fetching clients:', error)
          this.clientResults = [
            { id: 'add', nume: '➕ Adaugă client' }
          ]
        } finally {
          this.loading = false
        }
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      async fetchOrder (series, number) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order?series=${series}&number=${number}&externalCompanyId=${this.companyID}`)
          if (!response.ok) {
            throw new Error(`Eroare la fetch order: ${response.status}`)
          }

          const data = await response.json()

          if (data) {
            this.myOrder = {
              ...data
            }

            if (data.externalLocationId) {
              this.selectedLocationId = data.externalLocationId
            }

            this.items = data.products.map(item => {
              const quantity = item.quantity_faptic || item.quantity_scriptic || 0
              const priceRON = item.pret_fara_tva || 0
              const vatRate = item.tva_percent != null ? item.tva_percent : ''
              const includeVAT = vatRate > 0 ? 'yes' : 'no'

              const priceFaraTVA = priceRON
              const tvaUnit = (priceFaraTVA * vatRate) / 100

              const totalFaraTVA = priceFaraTVA * quantity
              const totalTVA = tvaUnit * quantity

              return {
                posId: item.posId,
                productName: item.productName || '',
                type: item.type || 'N/A',
                code: item.code || 'N/A',
                unitMeasure: item.unitMeasure || 'BUC',
                quantity: quantity,
                priceRON: (priceFaraTVA + tvaUnit).toFixed(2),
                vatRate: String(vatRate),
                includeVAT: includeVAT,
                gestiuneFrom: item.gestiune,
                priceFaraTVA: priceFaraTVA.toFixed(2),
                valoare: (totalFaraTVA + totalTVA).toFixed(2),
                tva: totalTVA.toFixed(2)
              }
            })

            if (this.locations && this.locations.length) {
              this.populateClientFromLocation()
            }
          } else {
            console.error('Comandă invalidă primită:', data)
            swal({
              title: 'Eroare',
              text: 'Comanda nu a fost găsită.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          console.error('Eroare la fetch order:', error)
          swal({
            title: 'Eroare',
            text: 'A apărut o problemă la încărcarea comenzii.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      async getInvoiceDetails (invoiceId) {
        if (!invoiceId) {
          console.error('Missing invoice ID')
          return
        }

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument/?tip=aviz&series=${this.series}&number=${this.invoiceNumber}&externalCompanyId=${this.companyID}`

        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const result = await response.json()
          const data = result.documents && result.documents.length ? result.documents[0] : null

          this.parentSeries = data.series
          this.parentInvoiceNumber = data.invoiceNumber

          this.invoiceData = data
          this.items = data.items.map(item => {
            const quantity = this.isStorno ? -1 * item.quantity : item.quantity
            const priceRON = item.price || 0      // preț fara TVA
            const vatRate = item.tva != null ? item.tva : 19
            const includeVAT = vatRate > 0 ? 'yes' : 'no'

            const priceFaraTVA = priceRON
            const totalFaraTVA = +(priceFaraTVA * quantity).toFixed(2)
            const totalTVA = +((priceFaraTVA * quantity * vatRate / 100).toFixed(2))
            const totalValoare = +(totalFaraTVA + totalTVA).toFixed(2)

            return {
              posId: item.posId,
              productName: item.name || '',
              type: item.type || 'N/A',
              code: item.code || 'N/A',
              unitMeasure: item.unitMeasure || 'BUC',
              quantity: quantity,
              priceRON: priceRON.toFixed(2),
              vatRate: String(vatRate),
              includeVAT: includeVAT,
              gestiuneFrom: item.gestiune_from,
              priceFaraTVA: priceFaraTVA.toFixed(2),
              valoare: totalValoare.toFixed(2),
              tva: totalTVA.toFixed(2)
            }
          })
          this.currency = data.currency
          this.seriesNumber = data.series
          this.clientName = data.customer.name
          this.clientCUI = data.customer.cnp
          this.clientEmail = data.customer.email
          this.clientPhone = data.customer.phone
          this.clientAddress = data.customer.address

          this.seriesOptions = [{
            series: data.series,
            currentNumber: data.invoiceNumber
          }]
          this.seriesNumber = data.series
          this.currentNumber = data.invoiceNumber

          if (data.extraFields) {
            this.extraFields = data.extraFields.reduce((acc, field) => {
              acc[field.key] = field.value
              return acc
            }, {})
          }

          this.issueDate = this.parseDateTimeLocal(data.issueDate || data.date)
          this.dueDate = this.parseDateTimeLocal(data.dueDate || data.date)

          if (data.externalLocationId && this.locations && this.locations.length) {
            // Căutăm locația potrivită în groupedLocations
            let foundLocation = null
            for (const group of this.groupedLocations) {
              foundLocation = group.locations.find(loc =>
                (data.externalLocationId && loc.true_id === data.externalLocationId) ||
                (data.vatNumber && loc.inv_fiscal_code === data.vatNumber)
              )
              if (foundLocation) break
            }
            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }

          if (data.customer) {
            console.log('Customer data found:', data.customer)
            const customer = data.customer
            const clientObj = {
              id: 'temp-' + customer.cnp,
              nume: customer.name,
              vatNumber: customer.cnp,
              fullData: customer
            }

            this.clientSelected = clientObj
            console.log('Selected client from invoice:', clientObj)
            this.onClientSelect(clientObj)
          }
        } catch (error) {
          console.error('Error fetching invoice details:', error)
        }
      },
      async fetchCompanyDetails (cui) {
        try {
          const company = await this.fetchAnafCompanyByCui(cui)
          this.applyAnafCompanyToFields(company, 'simpleClient')
        } catch (error) {
          console.error('Error fetching company details:', error)
        }
      },
      populateClientFromLocation () {
        if (this.myOrder && this.myOrder.supplierExternalLocationId) {
          const matchedLocation = this.locations.find(
            loc => loc.true_id === this.myOrder.supplierExternalLocationId
          )

          if (matchedLocation) {
            this.clientName = matchedLocation.inv_company_name || ''
            this.clientCUI = matchedLocation.inv_fiscal_code || ''
            this.clientAddress = matchedLocation.inv_address || ''
            this.clientEmail = matchedLocation.inv_email || ''
            this.clientPhone = matchedLocation.inv_phone || ''
            this.clientLegalStatus = 'juridica_ro'
            this.clientVATPayer = 'yes'
          }
        }
      },
      searchOrder () {
        const id = this.searchTerm ? parseInt(this.searchTerm.trim(), 10) : null
        var data = {
          token: this.$session.get('token'),
          company_id: this.companyID,
          id: id
        }

        if (!id) {
          swal({
            type: 'warning',
            title: 'Atenție',
            text: 'Te rog introdu un ID de comandă.'
          })
          return
        }

        swal({
          title: 'Se caută comanda...',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: {
            element: 'div',
            attributes: {
              innerHTML: '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>'
            }
          }
        })

        this.apiRequest('/get-products-from-order/', 'GET', data, (response) => {
          swal.close()

          if (response.status === true && response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
            this.isDisabled = true

            const firstGestiune = this.gestiuniList.length ? this.gestiuniList[0].name : ''
            this.receipt_number = response.data.receipt_number || null

            this.items = response.data.items.map(item => {
              const rawQuantity = parseFloat(item.quantity)
              const rawPrice = parseFloat(item.price)
              let quantity = Number.isFinite(rawQuantity) ? rawQuantity : 1
              let price = Number.isFinite(rawPrice) ? rawPrice : 0
              // Păstrăm quantity negativ din API; dacă price e încă negativ, mutăm semnul pe cantitate
              if (price < 0) {
                if (quantity > 0) quantity = -quantity
                else if (quantity === 0) quantity = -1
                price = Math.abs(price)
              }
              const vatRate = item.vat != null ? item.vat : ''
              const includeVAT = item.includeVAT === 'no' ? 'no' : 'yes'

              let priceFaraTVA = 0
              let tvaUnit = 0
              let priceCuTVA = 0

              if (includeVAT === 'yes') {
                priceCuTVA = price
                priceFaraTVA = price / (1 + vatRate / 100)
                tvaUnit = price - priceFaraTVA
              } else {
                priceFaraTVA = price
                tvaUnit = price * (vatRate / 100)
                priceCuTVA = price + tvaUnit
              }

              const totalFaraTVA = priceFaraTVA * quantity
              const totalTVA = tvaUnit * quantity

              return {
                productName: item.name || '',
                type: item.type || 'N/A',
                code: item.product_code || 'N/A',
                unitMeasure: item.unit || 'BUC',
                quantity: quantity,
                priceRON: priceFaraTVA.toFixed(2),     // << aici punem prețul fără TVA
                priceCuTVA: priceCuTVA.toFixed(2),
                vatRate: String(vatRate),
                includeVAT: includeVAT,
                gestiune: firstGestiune,
                priceFaraTVA: priceFaraTVA.toFixed(2),
                valoare: (totalFaraTVA + totalTVA).toFixed(2),
                tva: totalTVA.toFixed(2)
              }
            })

            swal({
              icon: 'success',
              title: 'Comandă găsită',
              text: `Am preluat ${this.items.length} articole din comandă.`
            })
          } else {
            swal({
              icon: 'error',
              title: 'Eroare',
              text: 'Comanda nu a fost găsită.'
            })
          }
        })
      },
      calculateItemTotals (item) {
        const quantity = Number(item.quantity) // Cantitatea
        const priceRON = Number(item.priceRON) // Prețul cu TVA inclus
        const vatRate = Number(item.vatRate) // Cota TVA
        const includeVAT = item.includeVAT === 'yes' // Verificăm dacă prețul include TVA

        console.log('Calculating totals for item:', vatRate)
        console.log('Include VAT:', includeVAT)

        let priceFaraTVA, tvaUnit, totalFaraTVA, totalTVA

        if (includeVAT) {
          // Dacă prețul include TVA, calculăm prețul fără TVA
          priceFaraTVA = priceRON / (1 + vatRate / 100) // Prețul fără TVA
          tvaUnit = priceRON - priceFaraTVA // TVA pe unitate
        } else {
          // Dacă prețul nu include TVA, atunci prețul fără TVA este direct priceRON
          priceFaraTVA = priceRON
          tvaUnit = priceFaraTVA * vatRate / 100 // Calculăm TVA pe unitate
        }

        // Calculăm totalurile pentru cantitatea selectată
        totalFaraTVA = priceFaraTVA * quantity // Total fără TVA
        totalTVA = tvaUnit * quantity // TVA total

        // Returnăm valorile calculate
        return {
          priceFaraTVA, // Prețul fără TVA
          total: totalFaraTVA + totalTVA, // Valoarea totală cu TVA inclus
          tva: totalTVA // TVA total
        }
      },
      addItem () {
        if (
          this.newItem.gestiuneId &&
          this.newItem.productName &&
          this.newItem.unitMeasure &&
          this.newItem.quantity > 0 &&
          this.newItem.priceRON > 0 &&
          this.newItem.type &&
          this.newItem.code &&
          this.newItem.vatRate !== null &&
          this.newItem.includeVAT !== ''
        ) {
          const totals = this.calculateItemTotals(this.newItem)

          console.log(totals)
          const newItemWithTotals = {
            ...this.newItem,
            priceRON: totals.priceFaraTVA.toFixed(2),
            valoare: totals.total.toFixed(2),
            tva: totals.tva.toFixed(2),
            gestiuneFrom: this.newItem.gestiuneId
          }
          console.log(this.newItem.posId)
          this.items.push(newItemWithTotals)
          this.resetNewItem()
        } else {
          // Mesaj de eroare dacă lipsește ceva
        }
      },
      getGestiuneName (gestiuneId) {
        const gestiune = this.gestiuneOptions.find(g => g.id === gestiuneId)
        return gestiune ? gestiune.name : 'N/A'
      },
      removeItem (index) {
        this.items.splice(index, 1)
      },
      resetNewItem () {
        this.newItem = {
          gestiuneId: null,
          productName: '',
          unitMeasure: '',
          quantity: null,
          priceRON: null,
          type: '',
          code: '',
          vatRate: '',
          includeVAT: 'no'
        }
      },
      async getSeries (vatNumber) {
        const tipSerie = this.route.query.edit === 'true'
          ? 'aviz'
          : (this.route.params.id !== 'add' ? 'invoice' : 'aviz')

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: tipSerie
            })
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()
          console.log('Serii primite:', data.series)

          if (Array.isArray(data.series) && data.series.length > 0) {
            this.seriesOptions = data.series.map(serie => ({
              series: serie.series,
              currentNumber: serie.currentNumber
            }))

            this.seriesNumber = this.seriesOptions[0].series
            this.currentNumber = this.seriesOptions[0].currentNumber
          } else {
            console.warn('Nu există serii disponibile pentru acest cod fiscal.')

            // Resetăm datele
            this.seriesOptions = []
            this.seriesNumber = ''
            this.currentNumber = ''
          }
        } catch (error) {
          console.error('Error fetching series:', error)

          // Resetăm datele
          this.seriesOptions = []
          this.seriesNumber = ''
          this.currentNumber = ''
        }
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')

          const data = await response.json()
          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuneOptions = data.gestiuni.map((gest) => ({
              id: gest._id,
              name: `${gest.name} (${gest.cod_gestiune})`,
              externalLocationId: gest.externalLocationId || ''
            }))
          } else {
            this.$message.error('Nu s-a primit un array valid de la server.')
          }
        } catch (error) {
          this.$message.error(`Request failed: ${error.message}`)
          console.error('Error fetching management data:', error)
        }
      },
      updateNumber () {
        if (this.seriesNumber === 'add') {
          this.openSeriesModal()
          return
        }

        const selectedSeries = this.seriesOptions.find(
          (series) => series.series === this.seriesNumber
        )

        if (selectedSeries) {
          this.currentNumber = selectedSeries.currentNumber
        } else {
          this.currentNumber = ''
        }
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      async fetchProducts (searchTerm) {
        if (!this.selectedLocation || !searchTerm || searchTerm.length < 2) {
          this.searchResults = []
          return
        }

        this.loadingProducts = true
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?vatNumber=${this.selectedLocation.inv_fiscal_code}&name=${encodeURIComponent(searchTerm)}&externalCompanyId=${this.companyID}`)
          const data = await response.json()

          if (Array.isArray(data.products)) {
            this.searchResults = [
              ...data.products
            ]
          }
        } catch (error) {
          console.error('Error fetching products:', error)
        } finally {
          this.loadingProducts = false
        }
      },
      onProductSelected (selectedProduct) {
        if (typeof selectedProduct === 'string' || !selectedProduct) {
          this.resetNewItem()
          return
        }

        this.newItem.posId = selectedProduct.posId || selectedProduct._id
        this.newItem.code = selectedProduct.product_code || ''
        this.newItem.type = selectedProduct.categorie || ''
        this.newItem.unitMeasure = selectedProduct.um
        this.newItem.quantity = selectedProduct.quantity || 1
        this.newItem.priceRON = (
          selectedProduct.pret_vanzare &&
          selectedProduct.pret_vanzare.length > 0 &&
          selectedProduct.pret_vanzare[0].price
        ) || ''
        this.newItem.vatRate = selectedProduct.vat_percent != null ? String(selectedProduct.vat_percent) : ''
        this.newItem.includeVAT = selectedProduct.is_with_vat ? 'yes' : 'no'
      },
      async updateOrderWithAviz (series, number) {
        const currentExternalDocs = this.myOrder.externalDocIds || {}

        const updateOrderPayload = {
          ...this.myOrder,
          externalDocIds: {
            ...currentExternalDocs,
            aviz: {
              series,
              number
            }
          },
          status: 'avizat'
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateOrderPayload)
          })

          if (!response.ok) {
            console.warn('Order update with aviz_id failed')
          } else {
            console.log('Order updated with aviz:', series, number)
          }
        } catch (err) {
          console.error('Error updating order with aviz_id:', err)
        }
      },
      async saveAviz () {
        // Verificăm dacă toate câmpurile obligatorii sunt completate
        if (!this.seriesNumber || !this.currency || !this.clientName || !this.clientCUI || !this.clientAddress) {
          swal({
            title: 'Error',
            text: 'Please complete all mandatory fields before saving the aviz.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        if (this.items.some(item => !item.productName || !item.unitMeasure || !item.quantity || !item.priceRON || !item.vatRate)) {
          swal({
            title: 'Error',
            text: 'Please complete all product details (name, unit measure, quantity, price, VAT rate).',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const invoiceData = {
          tip: 'aviz',
          externalCompanyId: this.companyID,
          dueDate: this.dueDate,
          issueDate: this.issueDate,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          items: this.items.map(item => ({
            name: item.productName.name || item.productName,
            type: item.type,
            code: item.code,
            posId: item.posId,
            unitMeasure: item.unitMeasure,
            quantity: item.quantity,
            price: parseFloat(item.priceRON),
            tva: item.vatRate,
            gestiune_from: item.gestiuneId || item.gestiuneFrom
          })),
          currency: this.currency,
          series: this.seriesNumber,
          customer: {
            name: this.clientName,
            cnp: this.clientCUI,
            email: this.clientEmail,
            phone: this.clientPhone,
            address: this.clientAddress
          },
          extraFields: Object.entries(this.extraFields).map(([key, value]) => ({ key, value }))
        }

        if (this.isEdit && this.invoiceData && this.invoiceData.invoiceNumber) {
          invoiceData.number = this.invoiceData.invoiceNumber
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/document`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(invoiceData) // Convertește obiectul în JSON
          })

          if (!response.ok) {
            const errorData = await response.json()
            const errorMessage = errorData.error || 'Error saving aviz'

            swal({
              title: 'Error',
              text: errorMessage,
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })

            throw new Error('Error saving aviz')
          }

          const data = await response.json()
          console.log('Aviz saved successfully:', data)

          const { isAviz } = this.route.query
          if (isAviz && data.series && data.invoiceNumber) {
            await this.updateOrderWithAviz(data.series, data.invoiceNumber)
          }

          swal({
            title: 'Success',
            text: 'Aviz saved successfully.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } catch (error) {
          console.error('Error saving aviz:', error)

          swal({
            title: 'Error',
            text: error.message || 'An unexpected error occurred.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      getClientTypeCode (status) {
        switch (status) {
          case 'juridica_ro':
            return 1 // Persoană juridică România
          case 'fizica':
            return 2 // Persoană fizică
          case 'juridica_vies':
            return 3 // PJ VIES
          default:
            return 1 // fallback
        }
      },
      async saveInvoice () {
        if (!this.seriesNumber || !this.currency || !this.clientName || !this.clientCUI || !this.clientAddress) {
          swal({
            title: 'Error',
            text: 'Please complete all mandatory fields before saving the invoice.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const invoiceData = {
          tip: 'invoice',
          externalCompanyId: this.companyID,
          dueDate: this.dueDate,
          issueDate: this.issueDate,
          externalLocationId: this.selectedLocationId,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          items: this.items.map(item => ({
            posId: item.posId,
            name: item.productName.name || item.productName,
            type: item.type,
            code: item.code,
            unitMeasure: item.unitMeasure,
            quantity: item.quantity,
            price: parseFloat(item.priceRON),
            tva: item.vatRate,
            gestiune_from: item.gestiuneId || item.gestiuneFrom
          })),
          currency: this.currency,
          series: this.seriesNumber,
          customer: {
            name: this.clientName,
            cnp: this.clientCUI,
            email: this.clientEmail,
            phone: this.clientPhone,
            address: this.clientAddress
          },
          extraFields: [
            ...Object.entries(this.extraFields).map(([key, value]) => ({ key, value })),
            { key: 'avizNumber', value: `${this.series}-${this.invoiceNumber}` }
          ]
        }

        if ((this.isInvoice || this.isEdit) && this.invoiceData && this.invoiceData.invoiceNumber) {
          invoiceData.invoiceNumber = this.invoiceData.invoiceNumber
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/document`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(invoiceData)
          })

          if (!response.ok) {
            const errorData = await response.json()
            const errorMessage = errorData.error || 'Error saving invoice'

            swal({
              title: 'Error',
              text: errorMessage,
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })

            throw new Error('Error saving invoice')
          }

          const data = await response.json()
          console.log('Invoice saved successfully:', data)

          swal({
            title: 'Success',
            text: 'Invoice saved successfully.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } catch (error) {
          console.error('Error saving invoice:', error)

          swal({
            title: 'Error',
            text: error.message || 'An unexpected error occurred.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      }
    }
  }
  </script>

  <style scoped>
  .btn-primary {
    padding: 5px 50px;
  }
  .box {
    display: flex ;
    justify-content: space-between;
    align-items: center;
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .button-group {
    display: flex;
    justify-content: flex-end;
  }
  .button-group .btn {
    margin-right: 10px;
  }
  .button-group .btn:last-child {
    margin-right: 0;
  }
  .v-select input[type=search], .v-select input[type=search]:focus, .v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
  }
  .totals-container {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 340px;
    font-size: 18px;
    margin-bottom: 5px;
  }

  .total-row .label {
    font-weight: 500;
    color: #25396F;
  }

  .total-row .value {
    font-weight: 600;
    color: #25396F;
  }

  .total-final .label {
    font-size: 18px;
    font-weight: bold;
  }

  .total-final .value {
    font-size: 18px;
    font-weight: bold;
  }
  td {
  position: relative;
}
.v-select-loader-product {
  position: absolute;
  right: 55px;
  top: 34%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.table thead tr > th {
  font-size: 14px;
}
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Outputs/ManagementAvizForm.vue